import { SiumpOperacao } from './siump-analise.model';

/** Nomes distintos dos trabalhadores da operação; sem contas, usa o titular do crédito informado na operação. */
export function nomesTitulares(operacao: SiumpOperacao): string[] {
  const dasContas = operacao.accounts
    .map(conta => conta.fields.find(campo => campo.id === 'workerName')?.text.trim() ?? '')
    .filter(Boolean);
  if (dasContas.length) {
    return [...new Set(dasContas)];
  }
  const beneficiario = operacao.record.fields.find(campo => campo.id === 'strBeneficiary')?.text.trim();
  return beneficiario ? [beneficiario] : [];
}
